export default __webpack_public_path__ + "static/media/ProfYangWANG.1dd7233f.png";